import { useState } from "react";

export function useCurrentOrPreviousNonFalsey<T>(value: T) {
    const [previous, setPrevious] = useState(value);

    if (value && value !== previous) {
        setPrevious(value);
    }

    return value || previous;
}
